<template>
    <v-layout row>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-btn
                    flat
                    slot="activator"
            >
                <v-icon left>edit</v-icon>Edit
            </v-btn>
            <v-card>

                <form v-on:submit.prevent="create">
                    <v-card-title>
                        <span class="headline">Edit admin</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 s12 md12>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.name"
                                            :error-messages="errors.collect('data.name')"
                                            label="Name"
                                            data-vv-name="data.name"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 s12 md12>
                                    <v-text-field
                                            v-validate="'required|email'"
                                            v-model="data.email"
                                            :error-messages="errors.collect('data.email')"
                                            label="Email"
                                            data-vv-name="data.email"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 s12 md12>
                                    <v-alert
                                            v-if="error != null"
                                            value="true"
                                            type="error"
                                    >
                                        {{ error }}
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                        <v-btn color="blue darken-1" flat type="submit">Edit</v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        props: ['admin'],
        data: () => ({
            dialog: false,
            data: {
                name: '',
                email: '',
                id: '',
            },
            error: null
        }),
        created () {
            this.data = Object.assign({}, this.admin);
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('updateAdmin', this.data).then((res) => {
                            this.$emit('created');
                            this.data = Object.assign({}, this.admin);
                            this.dialog = false
                        }).catch((error) => {
                            this.error = error.data.error;
                        });
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data = Object.assign({}, this.admin);
                this.error = null;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/admin/config/admins/components/EditModal.vue